import i18n from '../../locales/index'
import countTo from './count-to.vue'
export default countTo
